import React, { useState, Fragment } from "react"
import Lightbox from "yet-another-react-lightbox"
import Zoom from "yet-another-react-lightbox/plugins/zoom"
import { MdClose } from "react-icons/md"
import { FaPlus } from "react-icons/fa"
import { AiFillPicture } from "react-icons/ai"
import clsx from "clsx"

import { FileUploaderWrapper } from "components"
import classes from "./index.module.scss"

const ImageUploader = props => {
  const {
    values,
    onAdded,
    onRemoved,
    enableCrop,
    readOnly,
    isDeletable = false,
    aspectRatio,
    accountId,
    imageCategory,
    maxNumberOfUploads,
    rightSideIcon,
    placeholderSrc,
    preserveOriginalFile = false
  } = props

  const [photoIndex, setPhotoIndex] = useState(0)
  const [openGalleryPopup, setOpenGalleryPopup] = useState(false)

  const handleToggleLightBox = i => {
    setPhotoIndex(i)

    setOpenGalleryPopup(!openGalleryPopup)
  }

  const handleDeleteImage = (uploadedImage, index) => {
    onRemoved(uploadedImage, index)
  }

  const showFileInput =
    !readOnly &&
    !!isDeletable &&
    values.length < maxNumberOfUploads

  const imagesSlider = values.slice(0)

  const lightboxSlides =
    imagesSlider.map(url => ({ src: url }))

  const maxUpload =
    maxNumberOfUploads - values.length

  return (
    <Fragment>
      <div className={classes["container"]}>
        {
          showFileInput &&
          <FileUploaderWrapper
            accountId={accountId}
            imageCategory={imageCategory}
            enableCrop={enableCrop}
            preserveOriginalFile={preserveOriginalFile}
            aspectRatio={aspectRatio}
            onUploadComplete={onAdded}
            maxNumberOfUploads={maxUpload}
          >
            <div className={classes["file-input"]}>
              {
                placeholderSrc
                  ? (
                    <div className={classes["placeholder-container"]}>
                      <img
                        src={placeholderSrc}
                        className={classes["placeholder-image"]}
                        alt=""
                      />
                      <div className={classes["pic-icon"]}>
                        <AiFillPicture size={20} />
                        <FaPlus className={classes["pic-icon-plus"]} />
                      </div>
                    </div>
                  )
                  : (
                    <div className={classes["pic-icon"]}>
                      <AiFillPicture size={20} />
                      <FaPlus className={classes["pic-icon-plus"]} />
                    </div>
                  )
              }
            </div>
          </FileUploaderWrapper>
        }
        <div
          className={clsx(
            classes["row"],
            readOnly && classes["remove-margin"],
            maxUpload === 0 && classes["remove-margin"]
          )}
        >
          {imagesSlider.map((uploadedImage, index) =>
            <div
              key={uploadedImage}
              className={classes["image-container"]}
            >
              <img
                src={
                  preserveOriginalFile
                    ? uploadedImage
                    : `${uploadedImage}?width=100&quality=80`
                }
                className={classes["image"]}
                onClick={() => handleToggleLightBox((values.length - 1) - index)}
                alt=""
              />
              {
                isDeletable &&
                <button
                  className={classes["delete-icon"]}
                  onClick={() => handleDeleteImage(uploadedImage, index)}
                >
                  <MdClose />
                </button>
              }

              {
                !!rightSideIcon &&
                <div className={classes["righ-side"]}>
                  {rightSideIcon(index)}
                </div>
              }
            </div>
          )}
        </div>
      </div>
      <Lightbox
        open={openGalleryPopup}
        plugins={[Zoom]}
        index={photoIndex}
        styles={{
          toolbar: { direction: "ltr" }
        }}
        zoom={{
          scrollToZoom: true,
          maxZoomPixelRatio: 5
        }}
        close={() => setOpenGalleryPopup(false)}
        slides={lightboxSlides}
      />
    </Fragment >
  )
}

export default ImageUploader
